import { InjectionToken } from "@angular/core";
export const PARENT_TREE = /*#__PURE__*/new InjectionToken('Parent Tree');